//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const LOGOUT_TYPE: string = typeCreatorV2('AuthReducer', 'Logout');
export const LOGIN_TYPE: string = typeCreatorV2('AuthReducer', 'Login');
export const VERSION_TYPE: string = typeCreatorV2('AuthReducer', 'Version');
